import { useParams } from 'react-router-dom';

import { useOrganisationIntegrationByIds } from './useOrganisationIntegrationByIds';

/**
 * Hook to get the current organisation from Redux and its matching integration.
 *
 * Uses route params (workspaceId, organisationId) to look up the org in the
 * normalised Redux store, then matches the org's datasource.integration_id
 * to the full Integration object.
 *
 * Note: The Redux org's datasource is a DatasourceListingItem (lightweight),
 * not the full DataSource from the org details API.
 */
export const useOrganisationIntegration = (workspaceIdArg?: string, organisationIdArg?: string) => {
  const { workspaceId = '', organisationId = '' } = useParams();
  return useOrganisationIntegrationByIds(
    workspaceId || workspaceIdArg || '',
    organisationId || organisationIdArg || ''
  );
};
